<div (click)="onClick($event)" class="modal-test-component">
  <div>请求加入房间中，请稍等...</div>
</div>
